import { ParticipantAvatar } from '../../../services/participant.service';

interface Props {
  avatar: ParticipantAvatar;
}

export function AvatarCard({ avatar }: Props) {
  let statusColor: string;
  if (avatar.status === 'speaking') statusColor = 'bg-primary';
  else if (avatar.status === 'thinking') statusColor = 'bg-yellow-400';
  else statusColor = 'bg-white/30';

  return (
    <div className="flex-shrink-0 w-28 bg-white/5 border border-white/10 rounded-2xl p-3 text-center">
      <div className="relative inline-block mb-2">
        {avatar.imageUrl ? (
          <img src={avatar.imageUrl} alt={avatar.name} className="w-10 h-10 rounded-full object-cover mx-auto" />
        ) : (
          <div
            className="w-10 h-10 rounded-full flex items-center justify-center text-sm font-bold text-white mx-auto"
            style={{ backgroundColor: avatar.primaryColor || '#334155' }}
          >
            {avatar.name[0]}
          </div>
        )}
        <span className={`absolute bottom-0 right-0 w-2.5 h-2.5 rounded-full border-2 border-navy ${statusColor}`} />
      </div>
      <p className="text-white text-xs font-semibold truncate">{avatar.name}</p>
      <p className="text-white/40 text-xs truncate capitalize">{avatar.role.replace(/_/g, ' ')}</p>
    </div>
  );
}
